import { useState } from 'react'

import { AnimateBox } from '../../components/animate-box'
import { STATIC_OBS_URL } from '../../consts'

const data = [
  {
    id: '1',
    title: 'GCKontrol和GCAir助力高校教学科研',
    descriptions:
      '为全国超过 100 所高校提供仿真教学解决方案，支持课程建设和科研创新，培养新代仿真人才',
    thumbnail: `${STATIC_OBS_URL}/website/home/responsibility/r1.jpeg`,
    url: '/school'
  },
  {
    id: '2',
    title: '世冠科技公益助学',
    descriptions: '发起”科技创新助学计划"，为偏远地区学校捐赠仿真软件及配套设备，助力教育公平发展',
    thumbnail: `${STATIC_OBS_URL}/website/home/responsibility/r2.png`,
    url: '/responsibility'
  }
]

interface SectionEProps {
  title: string
}
export const SectionE = ({ title }: SectionEProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          以创新之力，担时代之责，世冠在人才培养与产业升级中践行科技报国使命
        </AnimateBox>
      </div>
      <ul className='wrap'>
        {data.map((item, index) => {
          const { title, descriptions, thumbnail, id, url } = item
          const key = id
          const classArr = ['card w700 h600 border p355-334']
          if (index === activeIndex) {
            classArr.push('active')
          }
          return (
            <AnimateBox
              animateDelay={1 + index * 0.2}
              className={classArr.join(' ')}
              key={key}
              onMouseEnter={() => {
                setActiveIndex(index)
              }}
            >
              <div className='img'>
                <div
                  className='pic'
                  style={{
                    backgroundImage: `url(${thumbnail})`
                  }}
                />
              </div>
              <div className='info'>
                <h5>
                  <a href={url}>{title}</a>
                </h5>
                <p>{descriptions}</p>
                <a className='look-more' href={url}>
                  了解更多
                </a>
              </div>
            </AnimateBox>
          )
        })}
      </ul>
    </>
  )
}
